import api from "../utils/api";

export const getTreeChecklist = (data) => {
    return api.get("/tree-checklist", { params: data });
};
